module.exports = __webpack_public_path__ + "img/tips4_title.eafcc3d1.jpg";